import React, { Component } from 'react';
import ReactDom from 'react-dom';
import { Provider } from 'react-redux';

import store from './store';
import AdheringParties from './components/adhering-parties';
import AdheringPartiesLookUp from './components/adhering-parties-look-up';

export class AdheringPartiesComponent extends Component {
	render() {
		return (
			<Provider store={ store }>
				<AdheringParties />
			</Provider>
		);
	}
}

export class AdheringPartiesLookUpComponent extends Component {
	render() {
		return (
			<Provider store={ store }>
				<AdheringPartiesLookUp />
			</Provider>
		);
	}
}

var AdheringPartiesElement = document.getElementById( 'adhering-parties-element' ),
    AdheringPartiesLookUpElement  = document.getElementById( 'adhering-parties-lookup-element' );
if ( AdheringPartiesElement ) {
	ReactDom.render( <AdheringPartiesComponent />, AdheringPartiesElement );
} else if ( AdheringPartiesLookUpElement ) {
	ReactDom.render( <AdheringPartiesLookUpComponent />, AdheringPartiesLookUpElement );
}